import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=94c5a9dc"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94c5a9dc')) {
      api.createRecord('94c5a9dc', component.options)
    } else {
      api.reload('94c5a9dc', component.options)
    }
    module.hot.accept("./Table.vue?vue&type=template&id=94c5a9dc", function () {
      api.rerender('94c5a9dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Placeholder/Table.vue"
export default component.exports